import React from "react";
import { Alert } from "react-bootstrap";
import { PageHeader } from "src/components";

function InfoComponent() {
  return (
    <div>
      <PageHeader>
        <h1>Info</h1>
      </PageHeader>
      <p>
        Welcome to the Workflow Page! Here you can use the automated workflows to help for your testing and development. <br />
        Before you get started, please make sure you have read the following documentation:
      </p>
      <Alert variant="info">
        Please ensure <b>TEST_API_ENABLED=true</b> and set <b>USER_CREATES_PER_HOUR</b> to a high number when you are building the collection server. <br />
        <code>TEST_API_ENABLED=true USER_CREATES_PER_HOUR=999 bash docker/docker-compose/start-latest.sh</code>
        <hr />
        The Preveil website may become buggy if you have too many local accounts. <br />
        Delete the accounts you don't need from the Crypto Server Database after you are done with them.
        <code>sudo sqlite3 /var/preveil/daemon/modes/dev/user_db.sqlite "delete from Store where tag != '$user_id_to_keep';"</code>
        <hr />
        Please ensure you are on the local port (default is 2003) and not on the express port (default is 2019).
        <hr />
        Please avoid using the same user_id when creating multiple accounts to prevent any unwanted issues (best to use the provided default user_id).
      </Alert>
      <h4>Organization</h4>
      <Alert variant="info">
        The organization list is fetched from the admin users in the local account list. <br />
        Please ensure the admin users are in your local account list.
        <hr />
        Adding users to an organization with approval group is not tested. <br />
        Please avoid doing this.
      </Alert>
    </div>
  );
}

export default React.memo(InfoComponent);
